import Ellipses from '@common/EllipsesPresets/EllipsesPresets';
import React from 'react';
import styled from 'styled-components';

const DelegateItem = (props) => {
	const {user} = props;
	return (
		<StyledSection {...props}>
			<section className="delegate-name">
			   <Ellipses.Single>{`${user.firstName} ${user.lastName}`}</Ellipses.Single> 
			</section>			
			<section className="delegate-email">{user.emailAddress}</section>
		</StyledSection>
	);
};

export default DelegateItem;

const StyledSection = styled.section`
	display: flex;
	flex-flow: column;
	border: 0.1rem solid ${(props) => props.theme.color[`grey300`]};
	width: calc(100% - 3rem);
	background-color: ${(props) =>
		props.activeTab === '1' ? 'transparent' : props.theme.color[`grey100`]};
	padding: 0.5rem 0.5rem 0.5rem 1.5rem;
	.delegate-name {
		font-weight: bold;
		font-size: 1.4rem;
		margin-bottom: 0.5rem;
		color: ${(props) => props.theme.color[`grey500`]};
	}
	.delegate-email {
		font-weight: 300;
		font-size: 1.4rem;
		color: ${(props) => props.theme.color[`grey400`]};
	}
`;
